import { createContext } from 'react';

export const IsPDFContext = createContext<boolean>(false);
